import { Small } from "@fronterahealth/frontera-ui-components";
import { Item, ItemActions, ItemContent, ItemTitle } from "@fronterahealth/frontera-ui-components/ui/item";

import { ReviewItemFieldsFragment } from "@api/graphql/types-and-hooks";
import { AuthorAvatar } from "@components/QaReview/components/AuthorAvatar";
import { AuthorName } from "@components/QaReview/components/AuthorName";
import { CommentActionReply } from "@components/QaReview/components/CommentActionReply";
import { CommentBody } from "@components/QaReview/components/CommentBody";
import { CommentActionMenu } from "@components/QaReview/components/CommentMessage";
import { Timestamp } from "@components/QaReview/components/Timestamp";

interface CommentReplyProps {
  reply: ReviewItemFieldsFragment;
}

// One reply inside a thread card: a header row, then the body at the card's content edge (not under the
// name), to save width in the narrow panel. No card, badge, field line or checkmark of its own.
export const CommentReply: React.FC<CommentReplyProps> = ({ reply }) => (
  <div className="space-y-1" data-testid="comment-reply">
    <Item size="xs" className="min-w-0 flex-nowrap border-0 p-0">
      <AuthorAvatar comment={reply} />
      {/* min-w-0 + truncate: long names shorten with "…" so the buttons and timestamp stay on the row. */}
      <ItemContent className="min-w-0">
        <ItemTitle className="max-w-full min-w-0 items-baseline gap-1.5">
          <span className="min-w-0 [&>p]:truncate">
            <AuthorName comment={reply} />
          </span>
          {reply.__typename === "ReportCommentType" && (
            <Small className="shrink-0 whitespace-nowrap text-text-tertiary">
              <Timestamp value={reply.createdDate} />
            </Small>
          )}
        </ItemTitle>
      </ItemContent>
      <ItemActions className="shrink-0 self-start">
        <CommentActionReply comment={reply} iconOnly />
      </ItemActions>
      <CommentActionMenu comment={reply} />
    </Item>

    <CommentBody comment={reply} />
  </div>
);
